import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { ComboBox } from '@reveni-io/reveni-ui'

import { referenceDates } from './constants'

const ReferenceDateSelector = ({ referenceDate, onChangeReferenceDate, disabled }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  return (
    <ComboBox
      backgroundColor={theme.colors.background.primary}
      label={t('A contar desde')}
      menuItems={referenceDates.map(option => ({ value: option.value, label: t(option.label) }))}
      handleChange={e => onChangeReferenceDate(e.target.value)}
      value={referenceDate}
      disabled={disabled}
    />
  )
}

export default ReferenceDateSelector
